module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_8023.58a45102.png";